import { render, staticRenderFns } from "./BomInfoContent.vue?vue&type=template&id=7d8d680a&"
import script from "./BomInfoContent.vue?vue&type=script&lang=js&"
export * from "./BomInfoContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports